import { Translation } from "./translations";

interface SelectedSection {
  id: number;
  name: string;
  quantity?: number;
  price: number;
  isUpselling: boolean;
}

interface SelectedComboChoices {
  productId: number;
  quantity: number;
  isUpselling?: boolean;
  receiptName?: Translation;
  total?: number;
}

interface SelectedLineComboChoices {
  lineId: number;
  comboChoices: SelectedSection[];
}

export type { SelectedComboChoices, SelectedLineComboChoices, SelectedSection };
